import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PointsTransactionHistoryComponent } from './points-transaction-history.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { NgxPaginationModule } from 'ngx-pagination';
import { DateDefaultFormatPipe } from 'src/app/pipes/date-format.pipe';



@NgModule({
  declarations: [
    PointsTransactionHistoryComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgxPaginationModule,
    ComponentsModule,
    DateDefaultFormatPipe
  ],
  exports: [ PointsTransactionHistoryComponent ]
})
export class PointsTransactionHistoryModule { }
